module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAABCAYAAACbv+HiAAAAFUlEQVQokWN89+7df4ZRMApGAVYAANVAA8uw8mU9AAAAAElFTkSuQmCC"